import { Select, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import "./statusSelector.css";
import { ReactComponent as Tick } from "../../assets/icons/tick.svg";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const StatusSelector = ({ setStatusId }) => {
  const location = useLocation();
  const urlParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const formatEnumToTitleCase = (value) =>
    value &&
    value
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const defaultStatus = useMemo(
    () => formatEnumToTitleCase(urlParams.get("status")) || "PENDING",
    [urlParams]
  );

  const [status, setStatus] = useState(defaultStatus);
  const statusRes = useSelector((state) => state?.orderStatus?.statuses);

  const statusList = useMemo(() => {
    const baseStatusList = [{ id: "ALL", value: "All" }];

    const mappedStatuses =
      statusRes?.map((status) => ({
        id: status.code,
        value: status.name,
      })) || [];

    return [...baseStatusList, ...mappedStatuses];
  }, [statusRes]);

  useEffect(() => {
    const selectedStatus = statusList.find((item) => item.id === defaultStatus);
    if (selectedStatus) {
      setStatusId(selectedStatus.id);
    }
  }, [defaultStatus, statusList, setStatusId]);

  const handleStatusChange = useCallback(
    (event) => {
      const selectedStatus = statusList.find(
        (statusItem) => statusItem.value === event.target.value
      );
      setStatus(event.target.value);
      setStatusId(selectedStatus.id);
    },
    [statusList, setStatusId]
  );

  return (
    <Select
      className="status-select"
      value={status}
      onChange={handleStatusChange}
      renderValue={(selected) => {
        const selectedDisplayValue =
          statusList.find((statusItem) => statusItem.id === selected)?.value ||
          selected;
        return selectedDisplayValue;
      }}
      MenuProps={{
        MenuListProps: {
          sx: {
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
              },
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "transparent",
            },
          },
        },
      }}
    >
      {statusList.map((statusItem) => {
        return (
          <MenuItem
            key={statusItem.id}
            value={statusItem.value}
            sx={{
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "transparent",
              },
              "&.Mui-selected": {
                backgroundColor: "transparent",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <ListItemText
              primary={statusItem.value}
              sx={{
                color: "inherit", // Keeps text color unchanged
              }}
            />
            {(status === statusItem.id || status === statusItem.value) && (
              <Tick />
            )}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default StatusSelector;
